import { ReferenceNumberViewModel } from "src/app/view-models/reference-number.view-model";
import { StoredReferenceNumber } from "../models/stored-orders/stored-reference-number";
import { IStoredMapper } from "./stored-mapper";

/**
 * Mapping class that maps between ReferenceNumber view model and database StoredReferenceNumber.
 */
export class ReferenceNumberMapper implements IStoredMapper<ReferenceNumberViewModel, StoredReferenceNumber> {
	/**
	 * Maps a ReferenceNumber to a StoredReferenceNumber.
	 * @param referenceNumber The reference number data to convert.
	 * @returns A StoredReferenceNumber object.
	 */
	public ToStored(referenceNumber: ReferenceNumberViewModel): StoredReferenceNumber {
		return {
			Number: referenceNumber.Number,
			Type: referenceNumber.Type
		};
	}

	/**
	 * Maps a StoredReferenceNumber to a ReferenceNumber.
	 * @param storedReferenceNumber The stored reference number data to convert.
	 * @returns A ReferenceNumber object.
	 */
	public FromStored(storedReferenceNumber: StoredReferenceNumber): ReferenceNumberViewModel {
		return {
			Number: storedReferenceNumber.Number,
			Type: storedReferenceNumber.Type
		};
	}
}